<template>
  <div class="kurs-reg-modal">
    <div class="kurs-reg-modal__inner">
      <img
        src="/v2/ege/modal/close-ege.svg"
        alt="close"
        class="kurs-reg-modal__close"
        @click="$emit('closeModal')"
      >

      <h6 class="kurs-reg-modal__title">
        Зарегистрируйся и&nbsp;получи доступ к&nbsp;урокам
        и&nbsp;стратегию подготовки к&nbsp;{{ isOge ? 'ОГЭ' : 'ЕГЭ' }}
      </h6>

      <div class="kurs-reg-modal__fields">
        <form-name-field
          ref="nameField"
          v-model="nameInput"
          class="form__input kurs"
          placeholder="Имя"
        />

        <form-phone-field
          ref="phoneField"
          v-model="phoneInput"
          class="form__input form__input_phone kurs"
          :errors-list="submitError"
          :error="validForm === false"
        />

        <form-email-field
          ref="emailField"
          v-model="emailInput"
          class="form__input form__input_email kurs"
          :submit-error="submitError"
          placeholder="Почта"
          @clearSubmitError="clearSubmitError"
        />
      </div>

      <button
        class="kurs-reg-modal__btn"
        @click="submitReg"
      >
        Перейти к курсу
      </button>

      <p class="kurs-reg-modal__law">
        Нажимая на кнопку, вы соглашаетесь
        <br>
        <nuxt-link
          to="/privacy"
          target="_blank"
        >
          c условиями обработки данных
        </nuxt-link>
      </p>

      <div
        v-if="!examCenyPage"
        class="kurs-reg-modal__social"
      >
        <p>
          Или напишите нам в чат:
        </p>

        <div class="kurs-reg-modal__social-items">
          <a
            href="https://wa.me/79686286327"
            target="_blank"
            rel="nofollow"
            class="whatsapp"
          >
            <img
              src="/v2/ege/modal/whatsapp.svg"
              alt="whatsapp"
            >
          </a>
          <a
            :href="$telegramBotLink($route)"
            target="_blank"
            rel="nofollow"
            class="telegram"
          >
            <img
              src="/v2/ege/modal/telegram.svg"
              alt="telegram"
            >
          </a>
          <a
            href="mailto:online.school@synergy.ru"
            target="_blank"
            rel="nofollow"
            class="email"
          >
            <img
              src="/v2/ege/modal/email.svg"
              alt="email"
            >
          </a>
        </div>
      </div>
    </div>

    <div
      class="kurs-reg-modal__overlay"
      @click="$emit('closeModal')"
    />
  </div>
</template>

<script>
import FormNameField from '@/components/v2/common/fileds/FormNameField.vue';
import FormEmailField from '@/components/v2/common/fileds/FormEmailField.vue';
import FormPhoneField from '@/components/v2/common/fileds/FormPhoneField.vue';
import sendLeadMixinConstructor from '@/mixins/sendLeadMixinConstructor';
import pagesLand from '~/data/pagesLand';
import redirector from '@/service/redirector';

const sendLeadMixin = sendLeadMixinConstructor({
  needPhone: true,
  needEmail: true,
  needToSendTitle: true,
});

export default {
  name: 'KursModal',
  components: {
    FormPhoneField,
    FormEmailField,
    FormNameField,
  },
  mixins: [sendLeadMixin],

  computed: {
    productId() {
      return 447;
    },

    isOge() {
      return this.$route.name.includes('oge');
    },
    examCenyPage() {
      return this.$route.name === 'ege-ceny' || this.$route.name === 'oge-ceny';
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    onSubmit() {
      this.$vkPixel.reachGoal('Lead');
      this.$emit('success');
      this.closeModal();
    },
    async submitLead(dataForComments = false) {
      const sendLeadBody = {
        name: this.nameInput || '',
        phone: this.phoneInput || '',
        email: this.emailInput || '',
        landCode: this.landCode || pagesLand[this.$route.name] || pagesLand[this.$route.path],
      };

      if (dataForComments) {
        const invalidFields = [];
        dataForComments.errors.forEach((field) => {
          if (field.objectField === 'email') invalidFields.push('почтой');
          if (field.objectField === 'phone') invalidFields.push('телефоном');
        });

        if (invalidFields.length) {
          // eslint-disable-next-line max-len,vue/max-len
          sendLeadBody.comments = `Пользователь с таким ${invalidFields.join(', ')} уже есть в системе, добавление его в Марафон возможно только в ручном режиме`;
        } else {
          sendLeadBody.comments = 'При регистрации произошла ошибка, требуется добавление в Марафон в ручном режиме';
        }
      }

      const response = await this.$api.sendLead(sendLeadBody);

      if (response.success) {
        this.onSubmit();
      } else {
        this.validForm = false;
        this.submitError = response.errors;
      }
    },
    async handleAuthenticatedUser() {
      await this.$api.purchaseProduct({ productId: this.productId });

      await this.submitLead();
      window.location = redirector.linkToCore();
    },
    async handleUnauthenticatedUser() {
      const data = await this.$api.register({
        name: this.nameInput,
        email: this.emailInput,
        phone: this.phoneInput.replace('+', ''),
        landCode: this.landCode || pagesLand[this.$route.name] || pagesLand[this.$route.path],
      });

      if (!data.success) {
        await this.submitLead(data);
        this.$router.push('/thanks');
      } else {
        await this.$store.dispatch('login', data.student);
        // this.$cookies.set('auth', data.student.token);
        await this.$api.purchaseProduct({ productId: this.productId });
        window.location = redirector.linkToCore();
      }
    },
    async handleRegScenario() {
      if (this.$store.getters.user) {
        await this.handleAuthenticatedUser();
      } else {
        await this.handleUnauthenticatedUser();
      }
    },
    async submitReg() {
      if (!this.checkValidate()) {
        return false;
      }

      this.sending = true;
      await this.handleRegScenario();
      this.sending = false;
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.kurs-reg-modal {
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  &__inner {
    width: 545px;
    max-height: 98vh;
    overflow: auto;
    box-sizing: border-box;
    padding: 40px;
    position: relative;
    z-index: 1;

    border-radius: 20px;
    border: 2px solid $black-color;
    background: $white-color;
    box-shadow: 4px 4px 0 0 #000;

    @include media-down(tablet) {
      width: 100%;
      max-width: 344px;
      padding: 40px 8px;
    }
  }
  &__inner {
    border: none;
    box-shadow: 4px 4px 20px 0 rgba($ege-blue-darkest, .05), 10px 10px 50px 0 rgba($ege-blue-darkest, .1);
  }

  &__close {
    position: absolute;
    right: 0;
    top: 0;

    cursor: pointer;
  }

  &__close {
    position: absolute;
    right: 0;
    top: 0;

    cursor: pointer;
  }

  &__title {
    text-align: center;
    font-size: 34px;
    font-weight: 700;
    line-height: 100%;
    letter-spacing: -1.2px;
    color: $black-color;

    @include media-down(tablet) {
      font-size: 24px;
      letter-spacing: -0.48px;
    }

    ::v-deep & > span {
      display: inline-block;
      position: relative;

      span {
        position: relative;
        z-index: 2;
        color: $ege-orange;
      }
    }
  }

  &__description {
    max-width: 414px;
    margin: 10px auto 0;

    text-align: center;
    font-variant-numeric: lining-nums proportional-nums;
    font-size: 24px;
    font-weight: 500;
    line-height: 130%;
    color: $grey2;

    @include media-down(tablet) {
      margin: 8px auto 0;

      font-size: 18px;
      font-weight: 600;
      line-height: 100%;
    }
  }

  &__fields {
    margin-top: 40px;

    @include media-down(tablet) {
      margin-top: 16px;
    }

    .form__input {
      margin: 0 auto 10px;

      @include media-down(tablet) {
        margin-bottom: 8px;
      }

      ::v-deep input:not(.phone-field__input) {
        width: 100%;
        height: auto;
        padding: 21px 18px;

        border-radius: 100px;
        border: 1px solid rgba($black-color, .2);

        font-size: 20px;
        font-weight: 400;
        letter-spacing: 0.4px;
        line-height: 1;
        color: $black-color;

        &::placeholder {
          color: $grey2;
        }

        @include media-down(tablet) {
          padding: 16px 14px 16.5px;

          font-size: 18px;
        }
      }

      ::v-deep .phone-field__input {
        padding-top: 20px;
        padding-bottom: 22px;

        font-size: 20px;
        font-weight: 400;
        letter-spacing: 0.4px;

        @include media-down(tablet) {
          font-size: 18px;
        }
      }
    }
  }

  &__btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 70px;
    margin-top: 20px;

    border-radius: 100px;
    background-color: $ege-orange;
    border: 2px solid $brown-dark;
    box-shadow: 0 4px 0 0 $brown-dark;

    text-align: center;
    font-variant-numeric: lining-nums proportional-nums;
    font-size: 30px;
    color: $white-color;
    font-weight: 700;
    line-height: normal;

    cursor: pointer;
    transition: transform .2s ease-out, box-shadow .2s ease-out;

    @include media-down(tablet) {
      margin-top: 8px;
      height: 60px;

      transform: translate(-4px, -4px);
      box-shadow: 4px 4px 0 0 $black-color;

      font-size: 24px;
    }

    &:hover {
      box-shadow: 0 0 0 0 $brown-dark;
      transform: translate(0, 4px);
    }
  }

  &__law {
    max-width: 384px;
    margin: 10px auto 0;

    text-align: center;
    font-variant-numeric: lining-nums proportional-nums;
    font-size: 18px;
    font-weight: 600;
    line-height: 100%;
    color: $grey2;

    @include media-down(tablet) {
      margin-top: 8px;

      font-size: 16px;
      line-height: 120%;
    }

    a {
      color: $ege-orange;
    }
  }

  &__social {
    margin-top: 32px;

    @include media-down(tablet) {
      margin-top: 24px;
    }

    p {
      font-variant-numeric: lining-nums proportional-nums;
      font-size: 20px;
      font-weight: 500;
      line-height: 26px;
      text-align: center;
      color: $black-color;

      @include media-down(tablet) {
        font-size: 16px;
        font-weight: 600;
        line-height: 19px;
      }
    }

    &-items {
      display: flex;
      justify-content: center;
      gap: 10px;
      margin-top: 16px;

      @include media-down(tablet) {
        margin-top: 12px;
      }

      a {
        display: inline-block;
        width: 50px;
        height: 50px;
        overflow: hidden;

        border-radius: 10px;
        transform: translate(-2px, -2px);

        transition: transform .2s ease-out, box-shadow .2s ease-out;

        img {
          width: 100%;
        }
      }
      a.whatsapp {
        border: 2px solid #168B25;
        box-shadow: 2px 2px 0 0 #168B25;

        &:hover {
          transform: translate(0, 0);
          box-shadow: 0 0 0 0 #168B25;
        }
      }
      a.telegram {
        border: 2px solid #016EA3;
        box-shadow: 2px 2px 0 0 #016EA3;

        &:hover {
          transform: translate(0, 0);
          box-shadow: 0 0 0 0 #016EA3;
        }
      }
      a.email {
        border: 2px solid #044396;
        box-shadow: 2px 2px 0 0 #044396;

        &:hover {
          transform: translate(0, 0);
          box-shadow: 0 0 0 0 #044396;
        }
      }
    }
  }

  &__overlay {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;

    background-color: rgba($black-color, 0.3);
    -webkit-backdrop-filter: blur(2.5px);
    backdrop-filter: blur(2.5px);

    cursor: pointer;
  }
}
</style>
